import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { VendorChatMessage } from 'app/models/forms/vendor/vendor-chat-message.model';

@Injectable({
	providedIn: 'root',
})
export class VendorChatService {
	constructor(private readonly httpClient: HttpClient) {}

	getMessages(clientId: string, formId: string): Observable<VendorChatMessage[]> {
		return this.httpClient.get<VendorChatMessage[]>(this.baseUrl(clientId, formId));
	}

	sendMessage(clientId: string, formId: string, text: string): Observable<VendorChatMessage> {
		return this.httpClient.post<VendorChatMessage>(this.baseUrl(clientId, formId), { text });
	}

	setReaction(
		clientId: string,
		formId: string,
		messageId: number,
		reaction: string | null
	): Observable<VendorChatMessage> {
		return this.httpClient.put<VendorChatMessage>(`${this.baseUrl(clientId, formId)}/${messageId}/reaction`, {
			reaction,
		});
	}

	markMessagesRead(clientId: string, formId: string): Observable<void> {
		return this.httpClient.put<void>(`${this.baseUrl(clientId, formId)}/read`, {});
	}

	getUnreadCount(clientId: string, formId: string): Observable<number> {
		return this.httpClient.get<number>(`${this.baseUrl(clientId, formId)}/unread-count`);
	}

	private baseUrl(clientId: string, formId: string): string {
		return `${environment.apiUrl}forms/clients/${clientId}/vendor/${formId}/chat-messages`;
	}
}
